module.exports = __webpack_public_path__ + "static/media/FuturaStd-Bold.1d71d9bf.ttf";